import { DatePipe, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Table } from 'primeng/table';
import { debounceTime } from 'rxjs';
import { FreelancerRequestService } from '../freelancer-request.service';
import { FreelancerRequestsFilterService } from '../freelancer-requests-filter.service';

@Component({
    selector: 'app-freelancer-requests-active-filters',
    templateUrl: './freelancer-requests-active-filters.component.html',
    standalone: true,
    imports: [NgFor, NgSwitch, NgIf, NgSwitchCase, DatePipe, TranslateModule]
})
export class FreelancerRequestsActiveFiltersComponent {

    formKeys: string[];
    formControls: Record<string, AbstractControl<any, any>>;
    queryId = '';
    personId = '';
    firstName = '';
    email = '';
    phoneNumber = '';
	@Input() table: Table;

	constructor(
		public readonly freelancerRequestsFilterService: FreelancerRequestsFilterService,
		public readonly freelancerRequestService: FreelancerRequestService
	) {
	    this.initializeFormControls();

	    this.freelancerRequestsFilterService.filterHandler()
	        .pipe(debounceTime(300))
	        .subscribe(() => {
	            this.freelancerRequestsFilterService.searchingByColumnFilter = true;
	            this.initializeFormControls();
	        });
	}

	initializeFormControls(): void {
	    this.formControls = this.freelancerRequestsFilterService.form.controls;
	    this.formKeys = [];

	    for (const key in this.formControls) {
	        if (Object.prototype.hasOwnProperty.call(this.formControls, key)) {
	            this.formKeys.push(key);
	        }
	    }

	    this.queryId = this.freelancerRequestsFilterService.form.controls['queryId'].value;
	    this.personId = this.freelancerRequestsFilterService.form.controls['personId'].value;
	    this.firstName = this.freelancerRequestsFilterService.form.controls['firstName'].value;
	    this.email = this.freelancerRequestsFilterService.form.controls['email'].value;
	    this.phoneNumber = this.freelancerRequestsFilterService.form.controls['phoneNumber'].value;
	}

	getFormControlObject(key: string): AbstractControl<any, any> {
	    return this.formControls[key];
	}

	isFilterActive(key: string): boolean {
	    const value = this.formControls[key].value;
	    return value != null && value !== '';
	}

	thereIsMoreThanOneFilterActive(): boolean {
	    return this.formKeys.filter(key => this.isFilterActive(key)).length >= 2;
	}

	clearFilter(key: string): void {
	    if (this[`${key}`]) this[`${key}`] = ''; // this.queryId = ''; this.personId = ''; this.firstName = ''; this.email = ''; this.phoneNumber = '';
	    this.freelancerRequestsFilterService.clearFilter(key);
	}

	clearAllFiltersAndGlobalSearch(): void {
	    this.queryId = '';
	    this.personId = '';
	    this.firstName = '';
	    this.email = '';
	    this.phoneNumber = '';
	    this.freelancerRequestsFilterService.clearAllFiltersAndGlobalSearch();

	    // reset sort field of the table
	    this.freelancerRequestsFilterService.resetSortField();
	    if (this.table) { this.table.reset(); }
	}
}
